var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcMoneyProfits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 237,
    viewBox: "0 0 317 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2073 211.5C32.6331 164.234 54.031 141.063 66.872 134.371C68.0682 133.748 69.4026 133.5 70.7515 133.5H97.0057C98.4559 133.5 99.9005 133.799 101.18 134.482C126.361 147.92 133.145 187.125 130.707 211.5C129.707 230.5 116.207 234 104.207 234H63.707C39.207 233 37.5405 217.667 37.2073 211.5Z",
    fill: "#BAC3D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 173.666C89.8952 172.608 86.6996 171.619 83.7116 171.63M76.0859 200.333C78.2515 201.323 81.0017 201.842 83.7116 201.473M83.7116 171.63C80.1104 171.644 76.8108 173.112 76.0859 177.666C75.1298 183.673 82.3775 185.829 86.6951 188C92.6635 191 92.6092 196.624 89.016 199.333C87.4 200.552 85.5652 201.22 83.7116 201.473M83.7116 171.63V167M83.7116 201.473V206",
    stroke: "#21325B",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.707,
    y: 122.5,
    width: 35,
    height: 8,
    rx: 4,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 54,
    width: 60,
    height: 12,
    rx: 6,
    fill: "#BAC3D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.707 116.5L57.707 96.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.707 116.5L109.207 96",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.207 96C60.5404 96.6667 67.907 96.9 70.707 92.5C73.507 88.1 77.207 89.3333 78.707 90.5L83.207 94.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.207 95.5976C105.874 96.2643 98.507 96.4976 95.707 92.0976C92.907 87.6976 89.207 88.931 87.707 90.0976L83.207 94.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.707 51L113.207 15.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.207 51L203.207 15",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.207 15.3628C118.976 16.511 131.726 16.9129 136.572 9.33494C141.419 1.75701 147.822 3.88113 150.419 5.89043L158.207 12.7795",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M203.207 14.3628C197.438 15.511 184.688 15.9129 179.842 8.33494C174.995 0.757011 168.592 2.88113 165.995 4.89043L158.207 12.4724",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.38959,
    y: 226.904,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    transform: "rotate(-61.5197 3.38959 226.904)",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 207.707,
    y: 188.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214.707,
    y: 205.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 207.707,
    y: 222.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 258.707,
    y: 222.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 266.707,
    y: 207.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 259.707,
    y: 191.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 250.707,
    y: 174.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 255.707,
    y: 157.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 88C120.5 80.1667 125.707 73.5 136.207 70H181.207C200.54 80.1667 232 111 230 176.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130 231H199.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.207 134C168.033 132.413 163.213 130.928 158.707 130.946M147.207 173.999C150.473 175.484 154.62 176.264 158.707 175.71M158.707 130.946C153.276 130.966 148.3 133.168 147.207 140C145.765 149.009 156.695 152.244 163.206 155.499C172.207 160 172.125 168.436 166.707 172.5C164.269 174.328 161.502 175.331 158.707 175.71M158.707 130.946V124M158.707 175.71V182.5",
    stroke: "#BAC3D7",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcMoneyProfits);
export default __webpack_public_path__ + "static/media/oc-money-profits.6e51d4210f91a38a2fa9a193dcc8554d.svg";
export { ForwardRef as ReactComponent };